{
  "name": "space-dashboard",
  "version": "2.14.2",
  "description": "Collection of happenings in space",
  "author": "Caleb Dudley",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "NODE_ENV=development vite",
    "build": "tsc && vite build",
    "preview": "vite preview",
    "build-preview": "yarn build && yarn preview",
    "format:check": "prettier --check ./src",
    "format:fix": "prettier --write ./src",
    "checks-before-push": "yarn lint && yarn format:check && yarn type-check",
    "changeset:add": "changeset add",
    "changeset:version": "changeset version",
    "changeset:publish": "changeset publish --no-git-tag",
    "update-version": "yarn changeset:version",
    "lint": "eslint --max-warnings 100",
    "type-check": "tsc --noEmit",
    "bundle-visualizer": "npx vite-bundle-visualizer -c vite.config.ts",
    "prepare": "husky"
  },
  "dependencies": {
    "@astrocaleb/content-slider": "1.0.0",
    "@date-fns/utc": "2.1.1",
    "@emotion/css": "11.13.5",
    "@sentry/react": "10.56.0",
    "@sentry/vite-plugin": "5.3.0",
    "@tabler/icons-react": "3.44.0",
    "@tanstack/react-query": "5.101.0",
    "axios": "1.20.0",
    "date-fns": "4.4.0",
    "posthog-js": "1.381.0",
    "react": "19.2.7",
    "react-dom": "19.2.7",
    "react-hook-form": "7.77.0",
    "react-is": "19.2.7",
    "react-toastify": "11.1.0",
    "react-tooltip": "5.30.1",
    "recharts": "3.8.1"
  },
  "devDependencies": {
    "@changesets/changelog-github": "0.7.0",
    "@changesets/cli": "2.31.0",
    "@eslint/compat": "2.1.0",
    "@eslint/js": "10.0.1",
    "@tanstack/react-query-devtools": "5.101.0",
    "@types/node": "22.19.20",
    "@types/react": "19.2.17",
    "@types/react-dom": "19.2.3",
    "@types/react-is": "19.2.0",
    "@typescript-eslint/eslint-plugin": "8.60.1",
    "@typescript-eslint/parser": "8.60.1",
    "@vitejs/plugin-react": "6.0.2",
    "eslint": "10.4.1",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.2",
    "eslint-plugin-sonarjs": "4.0.3",
    "globals": "17.6.0",
    "husky": "9.1.7",
    "prettier": "3.8.3",
    "process": "0.11.10",
    "typescript": "6.0.3",
    "vite": "8.1.6",
    "vite-bundle-visualizer": "1.2.1"
  },
  "lint-staged": {
    "**/*": "prettier --write --ignore-unknown"
  },
  "packageManager": "yarn@4.14.1"
}
